import React from 'react';

const ManageSkills = () => {
  return (
    <div className="page-content">
      <h2>Manage Skills</h2>
      <p>This is a dummy page for managing skills.</p>
    </div>
  );
};

export default ManageSkills;
